import { Container, ContainerProps, Divider } from '@mui/material';

export const PageSectionDivider = ({ maxWidth = 'lg' }: ContainerProps) => (
  <Container maxWidth={maxWidth}>
    <Divider flexItem sx={{ mx: 1 }} />
  </Container>
);
